module.exports = __webpack_public_path__ + "img/bar_banner.2b1b5287.png";